import { memo, useContext } from "react";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { DP } from "../../common/types";
import createCustomContext from "../../context/customContext";
import { ProfileContext } from "../../context/profileContext";
import CommentForm from "./components/CommentForm";
import PostComments from "./components/Comments";
import PostContent from "./components/Content";
import { IComment, IPost } from "./types";

interface IInitState {
  post?: IPost;
  isDeleted: boolean;
  comments: IComment[];
  isCommentsHidden: boolean;
  currentEditingCommentId?: string;
}

export const [usePostValue, usePost, withContext] =
  createCustomContext<IInitState>({
    isDeleted: false,
    comments: [],
    isCommentsHidden: true,
  });

interface Props extends DP {
  post: IPost;
}

const Post = (props: Props) => {
  const profile = useContext(ProfileContext);
 
  usePost({
    post: props.post,
  });
  const isDeleted = usePostValue((s) => s.isDeleted);

  if (isDeleted) return null;

  return (
    <Wrapper className={props.className}>
      <PostContent />
      <CommentsWrapper>
        {profile && <CommentForm />}
        <Hr />
        <PostComments />
      </CommentsWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
	tw`flex flex-col items-center w-full`,
  css`
    --user-picture-column-width: 1.5rem;
    --gap: 0.4rem;
    --comment-height: 1.8rem;
  `,
]);

const Hr = styled.div(() => [
  css`
    margin: 0.5rem 0;
    flex-grow: 1;
    height: 0.03rem;
    border-radius: 50%;
    overflow: hidden;
    ${tw`bg-pink-200`}
  `,
]);

const CommentsWrapper = styled.div(() => [
  tw`pl-[calc(var(--user-picture-column-width) + var(--gap))]`,
  tw`w-full md:(w-[16rem])`,
]);

export default styled(memo(withContext(Post)))``;
